import { useAuth } from '../context/AuthContext';
import { societeAStations } from '../lib/entitlements';

/**
 * Vrai quand la société a vraiment des stations à montrer. Un module station
 * ouvert ne suffit pas: le pack Transport et distribution les contient par
 * défaut, sans que la société en exploite une (voir `societeAStations`). Même
 * signal que le menu (« Plus > Stations », « Mes stations »).
 */
export default function useHasOwnStations() {
  const { user, activePack } = useAuth();
  return societeAStations({
    ownStations: user?.entitlements?.own_stations === true,
    activePack,
  });
}
